import { Typography, Link, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';

interface IErrorPageProps {
  status: string;
  statusMessage: string;
  additionalInfo?: string;
  suggestedLink?: string;
}

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(8),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  title: {
    paddingBottom: theme.spacing(5),
    [theme.breakpoints.down('xs')]: {
      paddingBottom: theme.spacing(4),
      fontSize: 32,
    },
  },
  subtitle: {
    color: theme.palette.textSubtle,
  },
}));

export const ErrorPage: FunctionComponent<IErrorPageProps> = ({
  status,
  statusMessage,
  additionalInfo,
  suggestedLink,
}: IErrorPageProps) => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <Grid container spacing={0} className={classes.container}>
      <Grid item xs={12} sm={8} md={4}>
        <Typography variant="body1" className={classes.subtitle}>
          ERROR {status}: {statusMessage}
        </Typography>
        <Typography variant="body1" className={classes.subtitle}>
          {additionalInfo}
        </Typography>
        {suggestedLink && (
          <Typography variant="body1" className={classes.subtitle}>
            <Link href={suggestedLink} rel="noopener noreferrer">
              {suggestedLink}
            </Link>
          </Typography>
        )}
        <br />
        <Typography variant="h2" className={classes.title}>
          Looks like someone dropped the mic!
        </Typography>
        <Typography variant="h6">
          <Link data-testid="go-back-link" onClick={() => navigate(-1)}>
            Go back
          </Link>
          ... or if you think this is a bug, please file an{' '}
          <Link href="https://github.com/AAInternal/runway/issues" rel="noopener noreferrer">
            issue.
          </Link>
        </Typography>
        <Typography variant="h6">
          You can also reach out to us on Slack at{' '}
          <Link href="https://americanairlines.slack.com/archives/C0112F1JKNG" rel="noopener noreferrer">
            #runway
          </Link>
        </Typography>
      </Grid>
    </Grid>
  );
};
